import { useTranslateEnum } from '@festina-life/ui/hooks'
import { useMemo } from 'react'

import type { ActionData } from '../components/commandActions/types'

export const useFormatWarnings = (
  warnings: NonNullable<ActionData['status']['warnings']>,
): string[] => {
  const translateEnum = useTranslateEnum()

  return useMemo(
    () =>
      warnings.map((warning) => {
        const message = translateEnum('enum.ActionWarningCode', warning.code)

        return warning.payload ? `${message} ${warning.payload}` : message
      }),
    [translateEnum, warnings],
  )
}
